module.exports = __webpack_public_path__ + "static/media/beka-avatar.9fd4c0f0.jpg";